/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa create link
 *
 */

Intesa.CreateLink = function() {
	
	console.log("stealth links pre init");
    
	this.init = function() {
		
		console.log("creating stealth links");
		
    }
    
    this.createLink = function(firstPart, secondPart) {
    	window.location.href = firstPart + '@' + secondPart;
    }
    
};

Intesa.CreateLink.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.create_link) {

        window.intesa.create_link = new Intesa.CreateLink();

    }

    return window.intesa.create_link;

};